import cloneDeep from "lodash.clonedeep";
import countries from "../constants/countries";
import serviceCall from "./service";
import { Environment } from "../Environment";
import { ONBOARD_STATUS, ONBOARD_ERROR, ORG_CREATE_TRIGGERED } from "../form-store/action-types";
import { resetCaptchaToken } from "../form-store/captcha-reducer";

function getCaptchaToken() {
  const { grecaptcha } = window;
  return new Promise((resolve, reject) =>
    grecaptcha.ready(function () {
      grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, {
          action: "homepage",
        })
        .then(function (token) {
          if (token) resolve(token);
          else reject("Error in token fetching");
        });
    })
  );
}

function convertTohtmlEntities(data) {
  if(data) {
    return data.toString().replace(/(<([^>]+)>)/ig, '');
  }
  return '';
}

async function createOrganization(formObj, dispatch, hcaptchaObj) {
  const orgInfoCpy = cloneDeep(formObj);
  const orgInfo = {};
  const { number, countryCode } = orgInfoCpy.primaryUser.phone;
  orgInfo.primaryUser = orgInfoCpy.primaryUser;
  orgInfo.primaryUser.firstName = convertTohtmlEntities(orgInfo.primaryUser.firstName);
  orgInfo.primaryUser.lastName = convertTohtmlEntities(orgInfo.primaryUser.lastName);
  orgInfo.primaryUser.phone.countryCode = orgInfoCpy.primaryUser.phone.countryCode.toUpperCase();
  const ctryIsdnObj = countries.find(ctry => ctry.value === countryCode.toUpperCase());
  orgInfo.primaryUser.phone.countryId = ctryIsdnObj.country_id;
  orgInfo.primaryUser.phone.number = number.replace(ctryIsdnObj.country_isd_code.replace("-", ""), "");
  orgInfo.primaryUser.phone.isdnCode = ctryIsdnObj.country_isd_code.replace("-", "");
  orgInfo.customer = orgInfoCpy.customer;
  orgInfo.customer = {
    ...orgInfo.customer,
    name: convertTohtmlEntities(orgInfo.customer.name),
    address: {
      line1: convertTohtmlEntities(orgInfo.customer.addressLine1),
      line2: convertTohtmlEntities(orgInfo.customer.addressLine2),
      line3: convertTohtmlEntities(orgInfo.customer.addressLine3),
      line4: convertTohtmlEntities(orgInfo.customer.addressLine4),
    }
  }
  orgInfo.customer.phone = orgInfo.primaryUser.phone;
  delete orgInfo.customer.addressLine1;
  delete orgInfo.customer.addressLine2;
  delete orgInfo.customer.addressLine3;
  delete orgInfo.customer.addressLine4;
  orgInfo.customer.countryCode = orgInfoCpy.customer.countryCode.value;
  orgInfo.customer.state = typeof orgInfoCpy.customer.state === "string" ? convertTohtmlEntities(orgInfoCpy.customer.state) : orgInfoCpy.customer.state.value;
  orgInfo.customer.city = typeof orgInfoCpy.customer.city === "string" ? convertTohtmlEntities(orgInfoCpy.customer.city) : orgInfoCpy.customer.city.value;
  orgInfo.customer.postalCode = typeof orgInfoCpy.customer.postalCode === "string" ? convertTohtmlEntities(orgInfoCpy.customer.postalCode) : orgInfoCpy.customer.postalCode.value;
  orgInfo.customer.county = typeof orgInfoCpy.customer.county === "string" ? convertTohtmlEntities(orgInfoCpy.customer.county) : orgInfoCpy.customer.county.value;

  let resp = {};
  let headers = {};
  const { hcaptcha, hcaptchaToken } = hcaptchaObj;
  if (hcaptcha) headers.hcaptcha = hcaptchaToken;
  else headers.gauth = await getCaptchaToken();

  try {
    resp = await serviceCall(Environment.SELF_ONBOARD, "POST", orgInfo, headers);
    resp = resp.data;
    resp.email = orgInfo.primaryUser.email;
    dispatch({ type: ONBOARD_STATUS, payload: resp });
    dispatch(resetCaptchaToken());
  } catch (error) {
    console.log(error);
    dispatch({ type: ONBOARD_ERROR, payload: true });
    dispatch({ type: ORG_CREATE_TRIGGERED, payload: false });
    dispatch(resetCaptchaToken());
  }
}

export default createOrganization;
